import { Component, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CompanyService } from '@core/client/company.service';
import { navigationItem } from '@core/navigation/navigation.model';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-navigation-listing',
    imports: [FontAwesomeModule, RouterLink, RouterLinkActive],
    templateUrl: './navigation-listing.component.html',
    styleUrl: './navigation-listing.component.scss',
    host:{
        class: 'd-flex flex-column'
    }
})
export class NavigationListingComponent {
    
    companyService = inject(CompanyService);

    navigation = input.required<navigationItem>();
    isCompany = input.required<boolean>();
    
    getCompanyChildUrl(url:any[]){
        if(url[0] == '/'){
            return url;
        }
        else{
            return ['company', this.companyService.company()?.id, ...url]
        }
    }

}
